import api from '../../../common/libs/api.js';
import Manage from '@/components/courseCenter/eight/public/Manage.vue';
import {mapState} from 'vuex';
import CourseBanner from '@/components/courseCenter/public/banner/Banner.vue';
import localforage from 'localforage';
import InfiniteLoading from '@/components/courseCenter/public/vue-infinite-loading/components/InfiniteLoading';
import _ from 'lodash';
import CityCodeData from '@/common/libs/CityCodeData';
import utils from '../../../common/libs/utils.js';

export default{
  name: 'Eight',
  components: {
    Manage,
    CourseBanner,
    InfiniteLoading
  },
  computed: mapState({
    city: state => state.home.city,
    coursesList: state => state.group.coursesList,
    consultantInfo: state => state.group.consultantInfo,
    category: state => state.group.conditions.category,
    first: state => state.group.first,
    isTouchEnd: state => state.group.isTouchEnd,
    noResult: state => state.group.noResult,
    msg: state => state.group.msg
  }),
  data(){
    return {
      phone: '',
      grade: '',
      banner: [], //轮播图
      tip: false,         //提示窗
      point: true,      //电话咨询窗
      haveRecommend: false,
      conditWord: '按距你最近的学习中心排序'
    }
  },
  metaData({store, route}){
    let city = CityCodeData.getCityByShort(route.params.city);

    store.dispatch("setMeta", {
      title: `面授8人班选课中心_中小学在线选课_${city.city_name}${city.brand||'学而思爱智康'}`,
      description: `${city.city_name+(city.brand||'学而思爱智康')}面授8人班选课中心提供小学、初中、高中面授8人班辅导，${city.brand||'学而思爱智康'}课程包括语文、数学、英语、物理、化学等科目的一对一辅导课、8人班小组课、精品课、在线课,选课热线：400-810-2680`,
      keywords: `${city.city_name+(city.brand||'学而思爱智康')}面授8人班,${city.city_name}${city.brand||'学而思爱智康'}8人班辅导,面授8人班选课中心,${city.city_name}${city.brand||'学而思爱智康'}在线选课`
    });
  },
  asyncData({store, route}){
    store.commit('resetGroup');
    let params = _.clone(store.state.group.conditions);
    let city = CityCodeData.getCityByShort(route.params.city);
    let location = store.state.home.location;

    params.city = (city&&city.city_code)||'010';
    params.category = '10002';
    params.type = route.query.type || '';
    params.grade = route.query.grade || store.state.course.grade.grid || '9';
    params.pn = 1;
    params.rn = 10;
    params.term = route.query.term || '';
    params.subject = route.query.subject || '';
    params.school_id = route.query.school_id || '';
    params.lat = location.lat || '';
    params.lng = location.lng || '';

    return store.dispatch('initGroupCourseList', {
      conditions: params
    });
  },
  watch: {
    $route(to, from) {
      this.$store.commit('resetGroup');

      let params = _.clone(this.$store.state.group.conditions);
      let city = CityCodeData.getCityByShort(this.$route.params.city);
      let location = this.$store.state.home.location;
      let route = this.$route;
      console.log('当前城市：', city);
      params.city = (city&&city.city_code)||'010';
      params.category = '10002';
      params.type = route.query.type || '';
      params.grade = route.query.grade || this.$store.state.course.grade.grid || '9';
      params.pn = 1;
      params.rn = 10;
      params.term = route.query.term || '';
      params.subject = route.query.subject || '';
      params.school_id = route.query.school_id || '';
      params.lat = location.lat;
      params.lng = location.lng;

      this.$store.dispatch('initGroupCourseList', {conditions: params});
      this.getBanners();
    }
  },
  methods: {
    infiniteHandler($state){
      if (this.isTouchEnd){
        return;
      }
      var params = _.clone(this.$store.state.group.conditions);
      params.pn = params.pn+1;
      this.$store.dispatch('getGroupCourseList', {
        conditions: params,
        $state: $state
      });
    },
    getBanners(){
      let vm = this;
      let city = CityCodeData.getCityByShort(this.$route.params.city);
      let obj = {
        city: city.city_code,
        category: '10002',
        grade: this.grade
      }
      api.apiMethod.courseBanner.post(obj).then(res => {
        if (res.data.errid == 0){
          vm.banner = res.data.content.list;
        } else {
          vm.$store.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    },
    filter(){
      this.$store.commit('isShowLoading', true);

      this.$router.push({name: 'conditions', query: {
        name: 'group',
        category: this.category,
        teaching_mode: '1001'
      }});
    },
    getWord(){
      let route = this.$route.query;
      this.conditWord = '';
      if (route.subjectMsg){
        this.conditWord += `${route.subjectMsg  } / `;
      }
      if (route.typeMsg){
        this.conditWord += `${route.typeMsg  } / `;
      }
      if (route.termMsg){
        this.conditWord += `${route.termMsg  } / `;
      }
      if (route.gradeMsg){
        this.conditWord += `${route.gradeMsg  } / `;
      }
      if (route.school_name){
        this.conditWord += route.school_name;
      }
    }
  },
  mounted(){
    this.$store.commit('isShowLoading', false);

    if (this.$route.query.gradeMsg){
      this.getWord();
    }

    let vm = this;

    localforage.getItem('izk-grade-list-grid').then(function(grade){
      if (grade){
        vm.grade = grade.grid;
      }
      vm.getBanners();
    })

    let stater = this.$store.state;
    let obj = {
      'page_name': '选课中心（面授8人班）',
      'locate_city': this.city.city_name,
      'user_grade': stater.course.grade.name || '三年级'
    }
    utils.bury('yd_izhikang_page_browse', obj);
  }
}


// WEBPACK FOOTER //
// ./src/components/courseCenter/eight/Eight.js